import { configureStore, combineReducers } from "@reduxjs/toolkit";
import forgetPasswordReducer from "./reducers/forgetPasswordSlice";
import registrationReducer from "./reducers/registrationSlice";
import phValidationReducer from "./reducers/phoneValidationSlice";
import changePasswordReducer from "./reducers/changePasswordSlice";
import userReducer from "./reducers/userSlice";
import prescriptionReducer from "./reducers/selectedPrescriptionSlice";
import prescriptionsReducer from "./reducers/prescriptionsSlice";
import patientReducer from "./reducers/patientSlice";
import prescriptionFormReducer from "./reducers/prescriptionFormSlice";
import medicalRecordReducer from "./reducers/medicalRecordSlice";
import sidebarReducer from "./reducers/sidebarSlice";
import investigationFilesReducer from "./reducers/investigationFilesSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "registration",
    "forgetPassword",
    "user",
    "patient",
    "selectedPrescription",
    "prescriptionForm",
    "sidebar",
  ],
};

const rootReducer = combineReducers({
  forgetPassword: forgetPasswordReducer,
  registration: registrationReducer,
  user: userReducer,
  phValidation: phValidationReducer,
  changePassword: changePasswordReducer,
  patient: patientReducer,
  selectedPrescription: prescriptionReducer,
  prescriptions: prescriptionsReducer,
  prescriptionForm: prescriptionFormReducer,
  medicalRecord: medicalRecordReducer,
  sidebar: sidebarReducer,
  investigationFiles: investigationFilesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        serializableCheck: false, // Adjust based on your needs
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
